var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-dialog',{attrs:{"title":"确定删除设备？","show-cancel-button":"","beforeClose":_vm.handleClose},model:{value:(_vm.dialogFormVisible),callback:function ($$v) {_vm.dialogFormVisible=$$v},expression:"dialogFormVisible"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }